import Info from '../../Components/ProductInfo/ProductInfo';
import { useDispatch, useSelector } from 'react-redux';
import {
  setProductInfoData,
  setCodes,
  deleteCodes,
  setCodesTitle,
  addBrands,
  addMeasurementUnit,
} from '../Slice';
import React from 'react';
import {
  addUnit as unitReq,
  addBrand as brandReq,
} from '../../tools/commonRequests';
interface IProps {
  setShowModal: (visible: any) => void;
  setModalTitle: (title: any) => void;
  // setOkText: Function;
  setModalContent: (child: any) => void;
  otherCodeForm;
  setDraft: () => void;
  setActive: () => void;
  setArchived: () => void;
  pageTitle: string;
  disabled?: boolean;
}

const ProductInfoSection = (props: IProps) => {
  const info = useSelector((state: any) => state.simpleProduct.productInfo);

  const brands = useSelector((state: any) => state.simpleProduct.brands);

  const measurementUnits = useSelector(
    (state: any) => state.simpleProduct.measurementUnits,
  );
  const status = useSelector((state: any) => state.simpleProduct.status);

  const dispatch = useDispatch();

  const {
    setShowModal,
    setModalTitle,
    // setOkText,
    setModalContent,
    otherCodeForm,
    setDraft,
    setActive,
    setArchived,
    pageTitle,
    disabled,
  } = props;
  const deletePopFun = (index) => {
    dispatch(deleteCodes({ index: index }));
  };
  const codesOnChange = (e, index) => {
    dispatch(setCodesTitle({ code: e, index }));
  };
  const setData = (data) => {
    dispatch(setProductInfoData(data));
  };
  const otherCodeFormFinish = (values) => {
    dispatch(setCodes({ title: values.Title, code: values.Code }));
    setShowModal(false);
  };
  const addUnit = (unit) => {
    unitReq({ unit }).then((u) => {
      dispatch(addMeasurementUnit(u));
    });
  };
  const addBrand = (brand) => {
    brandReq({ name: brand }).then((b) => {
      dispatch(addBrands(b));
    });
  };

  return (
    <Info
      disabled={disabled}
      title={pageTitle}
      addUnit={addUnit}
      addBrand={addBrand}
      brands={brands}
      measurementUnits={measurementUnits}
      status={status}
      setModalContent={setModalContent}
      // setOkText={setOkText}
      formdata={info}
      setShowModal={setShowModal}
      setModalTitle={setModalTitle}
      otherCodeForm={otherCodeForm}
      deletePopFun={deletePopFun}
      setCodes={setCodes}
      codesOnChange={codesOnChange}
      setData={setData}
      otherCodeFormFinish={otherCodeFormFinish}
      setDraft={setDraft}
      setActive={setActive}
      setArchived={setArchived}
    />
  );
};
export default ProductInfoSection;
